import { createAppProgressLoader } from '@sunlabde/vuelab/src/plugins/AppProgressLoader';

export const appProgressLoader = createAppProgressLoader();
